(ns frontend.ui.component.modal-dialog.core
  (:require
   [reagent.core :as r]))

(defn init-props
  ([]
   (init-props false))
  ([visible?]
   (let [atom-visible? (r/atom visible?)]
     {:atom-visible? atom-visible?
      :show          #(reset! atom-visible? true)
      :hide!         #(reset! atom-visible? false)})))
